import { render } from "./changeProblem.vue?vue&type=template&id=6ebd0678"
import script from "./changeProblem.vue?vue&type=script&lang=js"
export * from "./changeProblem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__